import {
  getFormattedLatestActivityTimestamp,
  roundToTwoDecimals,
} from '../../utils';

import s from './CourseTotal.module.css';
import {
  LAST_ACTIVITY_LAUNCHED_STRING,
  NO_ACTIVITY_HISTORY_STRING,
} from '../../constants';
import classNames from 'classnames';

export const CourseTotal = ({
  courseTotalPointsEarned,
  courseTotalPointsPossible,
  courseTotalPercent,
  showPercent,
  latestActivityLaunch,
  isMobile,
}) => {
  const totalEarned = roundToTwoDecimals(courseTotalPointsEarned);
  const totalPossible = roundToTwoDecimals(courseTotalPointsPossible);

  const renderFormattedActivityLaunchString = () => {
    if (latestActivityLaunch) {
      return (
        <div className={s.activityTimestamp}>
          <span>{LAST_ACTIVITY_LAUNCHED_STRING}</span>
          <span>
            {getFormattedLatestActivityTimestamp(
              latestActivityLaunch.launched_at,
            )}
          </span>
        </div>
      );
    }

    return (
      <span className={classNames(s.activityTimestamp, s.italic)}>
        {NO_ACTIVITY_HISTORY_STRING}
      </span>
    );
  };

  const renderPointsTotal = () => {
    return (
      <>
        <span className={s.earnedPoints}>{totalEarned}</span>
        <span className={s.possiblePoints}>out of {totalPossible} pts</span>
      </>
    );
  };

  const renderPercentTotal = () => {
    return <span className={s.earnedPercent}>{courseTotalPercent}</span>;
  };

  return (
    <div
      className={isMobile ? s.mobileContainer : s.desktopContainer}
      data-test-id={'isg-course-total'}
    >
      <div className={isMobile ? s.mobileTotal : s.desktopTotal}>
        {showPercent ? renderPercentTotal() : renderPointsTotal()}
      </div>
      {renderFormattedActivityLaunchString()}
    </div>
  );
};
